import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "CerCardStyled";

export const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  doneChip: `${PREFIX}-doneChip`,
  signedChip: `${PREFIX}-signedChip`,
};

export const CerCardStyled = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: "flex",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: "space-between",
    alignItems: "center",
    height: "40px",
    [`&.${classes.icon}`]: {
      padding: theme.spacing(1),
    },
    [`& .MuiChip-label`]: {
      fontWeight: 600,
      fontSize: 12,
    },
    [`& .${classes.doneChip}`]: {
      color: theme.palette.gray.dark,
      border: `1px solid ${theme.palette.gray.dark}`,
    },
    [`& .${classes.signedChip}`]: {
      color: theme.palette.success.main,
      border: `1px solid ${theme.palette.success.main}`,
    },
  },
}));
